import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  dark?: boolean;
};
export function SectionCTA({
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mt-10 flex flex-col items-center gap-3 sm:mt-12" data-id="element-60" data-mp="1lcbhxs1gufbm">
      <CTAButton data-id="element-61" data-mp="1qb4xrr486iey">{label}</CTAButton>
      <p className={`flex items-center gap-1.5 text-xs font-medium sm:text-sm ${dark ? 'text-white/70' : 'text-ink/60'}`} data-id="element-62" data-mp="1qad2yiigcopq">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-63" data-mp="1ge9w4zcno1wg" />
        One-time $27 · Instant access · 7-day guarantee
      </p>
    </div>;
}